// Module
var code = "<div class=\"page-settings-compta\"> <div class=\"title-buttons\"> <ap-button id=\"add-account\" type=\"add\"></ap-button> </div> <div class=\"content-settings\"> <ap-aggrid id=\"grid\"></ap-aggrid> </div> </div>";
// Exports
export default code;